export const getRestrictedCountries = () => {
    return [
        { value: 408, label: 'COREA DEL NORTE' },
        { value: 192, label: 'CUBA' },
        { value: 232, label: 'ERITREA' },
        { value: 364, label: 'IRAN' },
        { value: 368, label: 'IRAK' },
        { value: 422, label: 'LIBANO' },
        { value: 434, label: 'LIBIA' },
        { value: 104, label: 'MYANMAR' },
        { value: 140, label: 'REP. CENTROAFRICANA' },
        { value: 178, label: 'CONGO' },
        { value: 643, label: 'RUSIA' },
        { value: 760, label: 'SIRIA' },
        { value: 706, label: 'SOMALIA' },
        { value: 736, label: 'SUDAN' },
        { value: 804, label: 'UCRANIA' },
        { value: 862, label: 'VENEZUELA' },
        { value: 716, label: 'ZIMBABWE' }        
    ];
}

export const getRestrictedNationalities = () => {
    return [
        { value: 'CUBANO', label: 'CUBANO' },
        { value: 'ERITREO', label: 'ERITREO' },
        { value: 'IRANI', label: 'IRANI' },
        { value: 'IRAQUI', label: 'IRAQUI' },
        { value: 'LIBANES', label: 'LIBANES' },
        { value: 'LIBIO', label: 'LIBIO' },
        { value: 'BIRMANO', label: 'BIRMANO' },
        { value: 'CENTROAFRICANO', label: 'CENTROAFRICANO' },
        { value: 'CONGOLEÑO', label: 'CONGOLEÑO' },
        { value: 'CONGOLEÑO', label: 'CONGOLEÑO' },
        { value: 'RUSA', label: 'RUSA' },
        { value: 'RUSO', label: 'RUSO' },
        { value: 'SIRIO', label: 'SIRIO' },
        { value: 'SOMALI', label: 'SOMALI' },
        { value: 'SUDANES', label: 'SUDANES' },
        { value: 'UCRANIANO', label: 'UCRANIANO' },
        { value: 'VENEZOLANO', label: 'VENEZOLANO' },
        { value: 'ZIMBABWE', label: 'ZIMBABWE' }
        
    ];
}